import { render, staticRenderFns } from "./v-dialog-default.vue?vue&type=template&id=1878596a&scoped=true&"
import script from "./v-dialog-default.vue?vue&type=script&lang=js&"
export * from "./v-dialog-default.vue?vue&type=script&lang=js&"
import style0 from "./v-dialog-default.vue?vue&type=style&index=0&id=1878596a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878596a",
  null
  
)

export default component.exports